/*
  THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
  If you need to add or edit existing variables, check out
  discord_common/js/packages/tokens/definitions, then run
  `clyde mana tokens generate`
*/

const Colors = Object.freeze({
  APPLICATION_SUBSCRIPTION_END: '#0177a4',
  APPLICATION_SUBSCRIPTION_START: '#3442d9',
  BATTLENET: '#009ae5',
  BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_1: '#201e6e',
  BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_2: '#1d0066',
  BG_ANIMATED_GRADIENT_BACKGROUND_NOT_BLACK: '#0d0d0f',
  BG_ANIMATED_GRADIENT_BACKGROUND_PINK_1: '#eb459e',
  BG_GRADIENT_AURORA_1: '#062053',
  BG_GRADIENT_AURORA_2: '#191fbb',
  BG_GRADIENT_AURORA_3: '#13929a',
  BG_GRADIENT_AURORA_4: '#218573',
  BG_GRADIENT_AURORA_5: '#051a81',
  BG_GRADIENT_BLURPLE_TWILIGHT_1: '#2c3fe7',
  BG_GRADIENT_BLURPLE_TWILIGHT_2: '#261d83',
  BG_GRADIENT_CHROMA_GLOW_1: '#0eb5bf',
  BG_GRADIENT_CHROMA_GLOW_2: '#4c0ce0',
  BG_GRADIENT_CHROMA_GLOW_3: '#a308a7',
  BG_GRADIENT_CHROMA_GLOW_4: '#9a53ff',
  BG_GRADIENT_CHROMA_GLOW_5: '#218be0',
  BG_GRADIENT_CITRUS_SHERBERT_1: '#f3b336',
  BG_GRADIENT_CITRUS_SHERBERT_2: '#ee8558',
  BG_GRADIENT_COTTON_CANDY_1: '#f4abb8',
  BG_GRADIENT_COTTON_CANDY_2: '#b1c2fc',
  BG_GRADIENT_CRIMSON_MOON_1: '#950909',
  BG_GRADIENT_CRIMSON_MOON_2: '#000000',
  BG_GRADIENT_DESERT_KHAKI_1: '#e7dbd0',
  BG_GRADIENT_DESERT_KHAKI_2: '#dfd0b2',
  BG_GRADIENT_DESERT_KHAKI_3: '#e0d6a3',
  BG_GRADIENT_DUSK_1: '#665069',
  BG_GRADIENT_DUSK_2: '#91a3d1',
  BG_GRADIENT_EASTER_EGG_1: '#7289da',
  BG_GRADIENT_EASTER_EGG_2: '#4e5d94',
  BG_GRADIENT_FOREST_1: '#142215',
  BG_GRADIENT_FOREST_2: '#2d4d39',
  BG_GRADIENT_FOREST_3: '#454c32',
  BG_GRADIENT_FOREST_4: '#5a7c58',
  BG_GRADIENT_FOREST_5: '#a98e4b',
  BG_GRADIENT_HANAMI_1: '#efaab3',
  BG_GRADIENT_HANAMI_2: '#efd696',
  BG_GRADIENT_HANAMI_3: '#a6daa2',
  BG_GRADIENT_LOFI_VIBES_1: '#a4c0f7',
  BG_GRADIENT_LOFI_VIBES_2: '#a9e4e8',
  BG_GRADIENT_LOFI_VIBES_3: '#b0e2b8',
  BG_GRADIENT_LOFI_VIBES_4: '#cfdfa2',
  BG_GRADIENT_MARS_1: '#895240',
  BG_GRADIENT_MARS_2: '#8f4343',
  BG_GRADIENT_MIDNIGHT_BLURPLE_1: '#5348ca',
  BG_GRADIENT_MIDNIGHT_BLURPLE_2: '#140730',
  BG_GRADIENT_MINT_APPLE_1: '#56b69f',
  BG_GRADIENT_MINT_APPLE_2: '#63bc61',
  BG_GRADIENT_MINT_APPLE_3: '#9eca67',
  BG_GRADIENT_NEON_NIGHTS_1: '#01a89e',
  BG_GRADIENT_NEON_NIGHTS_2: '#7d60ba',
  BG_GRADIENT_NEON_NIGHTS_3: '#b43898',
  BG_GRADIENT_RETRO_RAINCLOUD_1: '#3a7ca1',
  BG_GRADIENT_RETRO_RAINCLOUD_2: '#7f7eb9',
  BG_GRADIENT_RETRO_STORM_1: '#3a7ca1',
  BG_GRADIENT_RETRO_STORM_2: '#58579a',
  BG_GRADIENT_SEPIA_1: '#857664',
  BG_GRADIENT_SEPIA_2: '#5b4421',
  BG_GRADIENT_STRAWBERRY_LEMONADE_1: '#af1a6c',
  BG_GRADIENT_STRAWBERRY_LEMONADE_2: '#c26b20',
  BG_GRADIENT_STRAWBERRY_LEMONADE_3: '#e7a525',
  BG_GRADIENT_SUNRISE_1: '#9f4175',
  BG_GRADIENT_SUNRISE_2: '#c49064',
  BG_GRADIENT_SUNRISE_3: '#a6953d',
  BG_GRADIENT_SUNSET_1: '#48288c',
  BG_GRADIENT_SUNSET_2: '#db7f4b',
  BG_GRADIENT_UNDER_THE_SEA_1: '#647962',
  BG_GRADIENT_UNDER_THE_SEA_2: '#588575',
  BG_GRADIENT_UNDER_THE_SEA_3: '#6a8482',
  BG_MODAL_GRADIENT_GREEN_DARK_1: '#20bb63',
  BG_MODAL_GRADIENT_GREEN_DARK_2: '#006638',
  BG_MODAL_GRADIENT_GREEN_LIGHT_1: '#e5fff0',
  BG_MODAL_GRADIENT_GREEN_LIGHT_2: '#8af7b5',
  BG_MODAL_GRADIENT_LAVENDER_DARK_1: '#a056f2',
  BG_MODAL_GRADIENT_LAVENDER_DARK_2: '#3e1689',
  BG_MODAL_GRADIENT_LAVENDER_LIGHT_1: '#dec2fc',
  BG_MODAL_GRADIENT_LAVENDER_LIGHT_2: '#ca9ef9',
  BG_MODAL_GRADIENT_MAGENTA_DARK_1: '#b3269c',
  BG_MODAL_GRADIENT_MAGENTA_DARK_2: '#660066',
  BG_MODAL_GRADIENT_MAGENTA_LIGHT_1: '#fbe6ff',
  BG_MODAL_GRADIENT_MAGENTA_LIGHT_2: '#fd99e9',
  BG_MODAL_GRADIENT_NAVY_DARK_1: '#5865f2',
  BG_MODAL_GRADIENT_NAVY_DARK_2: '#161a8a',
  BG_MODAL_GRADIENT_NAVY_LIGHT_1: '#c3c8fc',
  BG_MODAL_GRADIENT_NAVY_LIGHT_2: '#a0a9fa',
  BG_TILE_GRADIENT_MAGENTA_DARK_1: '#b3269c',
  BG_TILE_GRADIENT_MAGENTA_DARK_2: '#660066',
  BLACK: '#000000',
  BLACK_100: '#f2f2f2',
  BLACK_130: '#e8e8e8',
  BLACK_160: '#dadada',
  BLACK_200: '#cccccc',
  BLACK_230: '#bdbdbd',
  BLACK_260: '#acacac',
  BLACK_300: '#999999',
  BLACK_330: '#7a7a7a',
  BLACK_345: '#666666',
  BLACK_360: '#5c5c5c',
  BLACK_400: '#333333',
  BLACK_430: '#252525',
  BLACK_460: '#141414',
  BLACK_500: '#000000',
  BLACK_530: '#000000',
  BLACK_560: '#000000',
  BLACK_600: '#000000',
  BLACK_630: '#000000',
  BLACK_660: '#000000',
  BLACK_700: '#000000',
  BLACK_730: '#000000',
  BLACK_760: '#000000',
  BLACK_800: '#000000',
  BLACK_830: '#000000',
  BLACK_860: '#000000',
  BLACK_900: '#000000',
  BLUE_100: '#f6fafe',
  BLUE_130: '#f0f7fe',
  BLUE_160: '#e2f0fd',
  BLUE_200: '#cde8fd',
  BLUE_230: '#b2ddfc',
  BLUE_260: '#94d2fc',
  BLUE_300: '#66c4fd',
  BLUE_330: '#2eb6ff',
  BLUE_345: '#00aafc',
  BLUE_360: '#0097f2',
  BLUE_400: '#0082eb',
  BLUE_430: '#006be7',
  BLUE_460: '#005cd1',
  BLUE_500: '#0051b6',
  BLUE: '#0051b6',
  BLUE_530: '#00489b',
  BLUE_560: '#004088',
  BLUE_600: '#003976',
  BLUE_630: '#00336a',
  BLUE_660: '#002d5f',
  BLUE_700: '#002855',
  BLUE_730: '#002348',
  BLUE_760: '#001e3f',
  BLUE_800: '#001a36',
  BLUE_830: '#001630',
  BLUE_860: '#00132b',
  BLUE_900: '#001024',
  BLUE_NEW_1: '#e2efff',
  BLUE_NEW_10: '#b5d9ff',
  BLUE_NEW_100: '#000000',
  BLUE_NEW_11: '#b0d7ff',
  BLUE_NEW_12: '#abd4ff',
  BLUE_NEW_13: '#a7d2ff',
  BLUE_NEW_14: '#a3cfff',
  BLUE_NEW_15: '#9ecdff',
  BLUE_NEW_16: '#9acaff',
  BLUE_NEW_17: '#96c8ff',
  BLUE_NEW_18: '#91c5ff',
  BLUE_NEW_19: '#8dc3ff',
  BLUE_NEW_2: '#ddecff',
  BLUE_NEW_20: '#89c0ff',
  BLUE_NEW_21: '#85beff',
  BLUE_NEW_22: '#81bbff',
  BLUE_NEW_23: '#7db8ff',
  BLUE_NEW_24: '#79b6ff',
  BLUE_NEW_25: '#75b3fd',
  BLUE_NEW_26: '#72b1fc',
  BLUE_NEW_27: '#6eaefb',
  BLUE_NEW_28: '#6aacfa',
  BLUE_NEW_29: '#66a9f9',
  BLUE_NEW_3: '#d7eaff',
  BLUE_NEW_30: '#63a6f8',
  BLUE_NEW_31: '#5fa4f6',
  BLUE_NEW_32: '#5ba1f5',
  BLUE_NEW_33: '#579ff4',
  BLUE_NEW_34: '#549cf3',
  BLUE_NEW_35: '#5099f2',
  BLUE_NEW_36: '#4c97f0',
  BLUE_NEW_37: '#4894ef',
  BLUE_NEW_38: '#4491ee',
  BLUE_NEW_39: '#408fed',
  BLUE_NEW_4: '#d2e8ff',
  BLUE_NEW_40: '#3c8cec',
  BLUE_NEW_41: '#3889eb',
  BLUE_NEW_42: '#3387ea',
  BLUE_NEW_43: '#2f84e9',
  BLUE_NEW_44: '#2a81e8',
  BLUE_NEW_45: '#247fe7',
  BLUE_NEW_46: '#1e7ce6',
  BLUE_NEW_47: '#1779e5',
  BLUE_NEW_48: '#0d77e4',
  BLUE_NEW_49: '#0074e3',
  BLUE_NEW_5: '#cde5ff',
  BLUE_NEW_50: '#0074e3',
  BLUE_NEW_51: '#0272de',
  BLUE_NEW_52: '#046fd8',
  BLUE_NEW_53: '#056dd3',
  BLUE_NEW_54: '#066bce',
  BLUE_NEW_55: '#0668c9',
  BLUE_NEW_56: '#0666c4',
  BLUE_NEW_57: '#0664bf',
  BLUE_NEW_58: '#0662ba',
  BLUE_NEW_59: '#055fb5',
  BLUE_NEW_6: '#c8e3ff',
  BLUE_NEW_60: '#055db0',
  BLUE_NEW_61: '#045bac',
  BLUE_NEW_62: '#0358a7',
  BLUE_NEW_63: '#0256a3',
  BLUE_NEW_64: '#01549e',
  BLUE_NEW_65: '#00529a',
  BLUE_NEW_66: '#004f96',
  BLUE_NEW_67: '#004d91',
  BLUE_NEW_68: '#004b8d',
  BLUE_NEW_69: '#004989',
  BLUE_NEW_7: '#c3e0ff',
  BLUE_NEW_70: '#004785',
  BLUE_NEW_71: '#004481',
  BLUE_NEW_72: '#00427d',
  BLUE_NEW_73: '#004079',
  BLUE_NEW_74: '#003e75',
  BLUE_NEW_75: '#003c71',
  BLUE_NEW_76: '#00396d',
  BLUE_NEW_77: '#003769',
  BLUE_NEW_78: '#003565',
  BLUE_NEW_79: '#003361',
  BLUE_NEW_8: '#bedeff',
  BLUE_NEW_80: '#00315e',
  BLUE_NEW_81: '#002f5a',
  BLUE_NEW_82: '#002d56',
  BLUE_NEW_83: '#002b52',
  BLUE_NEW_84: '#00294f',
  BLUE_NEW_85: '#00274b',
  BLUE_NEW_86: '#002547',
  BLUE_NEW_87: '#002344',
  BLUE_NEW_88: '#002140',
  BLUE_NEW_89: '#001f3d',
  BLUE_NEW_9: '#b9dcff',
  BLUE_NEW_90: '#001d39',
  BLUE_NEW_91: '#001b36',
  BLUE_NEW_92: '#001932',
  BLUE_NEW_93: '#00172f',
  BLUE_NEW_94: '#00142b',
  BLUE_NEW_95: '#001226',
  BLUE_NEW_96: '#000f21',
  BLUE_NEW_97: '#000c1c',
  BLUE_NEW_98: '#000815',
  BLUE_NEW_99: '#00040b',
  BLURPLE_1: '#e5e9ff',
  BLURPLE_10: '#c2d1ff',
  BLURPLE_100: '#000000',
  BLURPLE_11: '#bfcfff',
  BLURPLE_12: '#bbccff',
  BLURPLE_13: '#b8c9ff',
  BLURPLE_14: '#b4c7ff',
  BLURPLE_15: '#b1c4ff',
  BLURPLE_16: '#aec1ff',
  BLURPLE_17: '#aabfff',
  BLURPLE_18: '#a7bcff',
  BLURPLE_19: '#a4b9ff',
  BLURPLE_2: '#e1e6ff',
  BLURPLE_20: '#a1b7ff',
  BLURPLE_21: '#9eb4ff',
  BLURPLE_22: '#9bb1ff',
  BLURPLE_23: '#98aeff',
  BLURPLE_24: '#95acff',
  BLURPLE_25: '#92a9ff',
  BLURPLE_26: '#90a6ff',
  BLURPLE_27: '#8da4ff',
  BLURPLE_28: '#8aa1ff',
  BLURPLE_29: '#879eff',
  BLURPLE_3: '#dde4ff',
  BLURPLE_30: '#859bff',
  BLURPLE_31: '#8299ff',
  BLURPLE_32: '#8096ff',
  BLURPLE_33: '#7d93ff',
  BLURPLE_34: '#7a90fe',
  BLURPLE_35: '#788efd',
  BLURPLE_36: '#768bfc',
  BLURPLE_37: '#7388fb',
  BLURPLE_38: '#7185fa',
  BLURPLE_39: '#6e82f9',
  BLURPLE_4: '#d9e1ff',
  BLURPLE_40: '#6c80f8',
  BLURPLE_41: '#6a7df7',
  BLURPLE_42: '#677af7',
  BLURPLE_43: '#6577f6',
  BLURPLE_44: '#6374f5',
  BLURPLE_45: '#6171f4',
  BLURPLE_46: '#5e6ef4',
  BLURPLE_47: '#5c6bf3',
  BLURPLE_48: '#5a68f3',
  BLURPLE_49: '#5865f2',
  BLURPLE_5: '#d5dfff',
  BLURPLE_50: '#5865f2',
  BLURPLE_51: '#5663ec',
  BLURPLE_52: '#5461e6',
  BLURPLE_53: '#525fe0',
  BLURPLE_54: '#505edb',
  BLURPLE_55: '#4e5cd5',
  BLURPLE_56: '#4c5ad0',
  BLURPLE_57: '#4a58cb',
  BLURPLE_58: '#4856c6',
  BLURPLE_59: '#4654c0',
  BLURPLE_6: '#d1dcff',
  BLURPLE_60: '#4452bb',
  BLURPLE_61: '#4250b6',
  BLURPLE_62: '#404eb2',
  BLURPLE_63: '#3e4cad',
  BLURPLE_64: '#3c4aa8',
  BLURPLE_65: '#3a48a3',
  BLURPLE_66: '#38469f',
  BLURPLE_67: '#36449a',
  BLURPLE_68: '#344296',
  BLURPLE_69: '#324091',
  BLURPLE_7: '#cdd9ff',
  BLURPLE_70: '#303e8d',
  BLURPLE_71: '#2e3c89',
  BLURPLE_72: '#2c3a84',
  BLURPLE_73: '#2a3880',
  BLURPLE_74: '#28367c',
  BLURPLE_75: '#273578',
  BLURPLE_76: '#253373',
  BLURPLE_77: '#23316f',
  BLURPLE_78: '#212f6b',
  BLURPLE_79: '#1f2d67',
  BLURPLE_8: '#cad7ff',
  BLURPLE_80: '#1d2b63',
  BLURPLE_81: '#1c295f',
  BLURPLE_82: '#1a275b',
  BLURPLE_83: '#182558',
  BLURPLE_84: '#172454',
  BLURPLE_85: '#152250',
  BLURPLE_86: '#13204c',
  BLURPLE_87: '#121e48',
  BLURPLE_88: '#101c45',
  BLURPLE_89: '#0f1a41',
  BLURPLE_9: '#c6d4ff',
  BLURPLE_90: '#0d193d',
  BLURPLE_91: '#0c173a',
  BLURPLE_92: '#0a1536',
  BLURPLE_93: '#091332',
  BLURPLE_94: '#07112e',
  BLURPLE_95: '#060f29',
  BLURPLE_96: '#050d24',
  BLURPLE_97: '#040a1e',
  BLURPLE_98: '#030716',
  BLURPLE_99: '#01030c',
  BRAND_100: '#f7f7fe',
  BRAND_130: '#f0f1fe',
  BRAND_160: '#e7e9fd',
  BRAND_200: '#dee0fc',
  BRAND_230: '#d4d7fc',
  BRAND_260: '#c9cdfb',
  BRAND_300: '#bcc1fa',
  BRAND_330: '#a8aff8',
  BRAND_345: '#9ba3f7',
  BRAND_360: '#949cf7',
  BRAND_400: '#7984f5',
  BRAND_430: '#707bf4',
  BRAND_460: '#6571f3',
  BRAND_500: '#5865f2',
  BRAND: '#5865f2',
  BRAND_530: '#505cdc',
  BRAND_560: '#4752c4',
  BRAND_600: '#3c45a5',
  BRAND_630: '#343b8f',
  BRAND_660: '#2d347d',
  BRAND_700: '#232861',
  BRAND_730: '#21265b',
  BRAND_760: '#1e2353',
  BRAND_800: '#1a1e49',
  BRAND_830: '#141738',
  BRAND_860: '#0d0f24',
  BRAND_900: '#04050c',
  BUNGIE: '#00a3e3',
  CRUNCHYROLL: '#f78b24',
  EBAY: '#0064d2',
  EPIC_GAMES: '#3c3935',
  FACEBOOK: '#355089',
  GITHUB: '#191717',
  GOLD: '#ffc819',
  GREEN_100: '#ecfef1',
  GREEN_130: '#defee7',
  GREEN_160: '#bdfcd3',
  GREEN_200: '#88fbb5',
  GREEN_230: '#58f39c',
  GREEN_260: '#48e58b',
  GREEN_300: '#3bd67f',
  GREEN_330: '#2dc771',
  GREEN_345: '#26b968',
  GREEN_360: '#23a55a',
  GREEN_400: '#24934e',
  GREEN_430: '#248045',
  GREEN_460: '#1f703c',
  GREEN_500: '#1a6334',
  GREEN: '#1a6334',
  GREEN_530: '#15562b',
  GREEN_560: '#124c24',
  GREEN_600: '#0e431f',
  GREEN_630: '#0c3c1c',
  GREEN_660: '#0a3618',
  GREEN_700: '#072f15',
  GREEN_730: '#052910',
  GREEN_760: '#03240e',
  GREEN_800: '#031f0c',
  GREEN_830: '#031b0a',
  GREEN_860: '#041708',
  GREEN_900: '#051307',
  GREEN_NEW_1: '#bcffca',
  GREEN_NEW_10: '#9beda9',
  GREEN_NEW_100: '#000701',
  GREEN_NEW_11: '#98eaa6',
  GREEN_NEW_12: '#95e8a3',
  GREEN_NEW_13: '#91e5a0',
  GREEN_NEW_14: '#8ee29c',
  GREEN_NEW_15: '#8be099',
  GREEN_NEW_16: '#88dd96',
  GREEN_NEW_17: '#84da93',
  GREEN_NEW_18: '#81d790',
  GREEN_NEW_19: '#7ed58d',
  GREEN_NEW_2: '#b8ffc6',
  GREEN_NEW_20: '#7bd28a',
  GREEN_NEW_21: '#78cf87',
  GREEN_NEW_22: '#75cd85',
  GREEN_NEW_23: '#71ca82',
  GREEN_NEW_24: '#6ec77f',
  GREEN_NEW_25: '#6bc47c',
  GREEN_NEW_26: '#68c279',
  GREEN_NEW_27: '#65bf76',
  GREEN_NEW_28: '#62bc74',
  GREEN_NEW_29: '#5eba71',
  GREEN_NEW_3: '#b4ffc2',
  GREEN_NEW_30: '#5bb76e',
  GREEN_NEW_31: '#58b46b',
  GREEN_NEW_32: '#55b269',
  GREEN_NEW_33: '#52af66',
  GREEN_NEW_34: '#4eac63',
  GREEN_NEW_35: '#4baa61',
  GREEN_NEW_36: '#47a75e',
  GREEN_NEW_37: '#44a55b',
  GREEN_NEW_38: '#40a258',
  GREEN_NEW_39: '#3c9f56',
  GREEN_NEW_4: '#b1fdbe',
  GREEN_NEW_40: '#399d53',
  GREEN_NEW_41: '#359a50',
  GREEN_NEW_42: '#30984e',
  GREEN_NEW_43: '#2c954b',
  GREEN_NEW_44: '#279348',
  GREEN_NEW_45: '#229045',
  GREEN_NEW_46: '#1c8e42',
  GREEN_NEW_47: '#158b40',
  GREEN_NEW_48: '#0c883d',
  GREEN_NEW_49: '#00863a',
  GREEN_NEW_5: '#adfabb',
  GREEN_NEW_50: '#00863a',
  GREEN_NEW_51: '#028339',
  GREEN_NEW_52: '#038138',
  GREEN_NEW_53: '#047e37',
  GREEN_NEW_54: '#047b36',
  GREEN_NEW_55: '#057834',
  GREEN_NEW_56: '#057633',
  GREEN_NEW_57: '#057332',
  GREEN_NEW_58: '#047031',
  GREEN_NEW_59: '#046e2f',
  GREEN_NEW_6: '#a9f8b7',
  GREEN_NEW_60: '#046b2e',
  GREEN_NEW_61: '#03692d',
  GREEN_NEW_62: '#02662c',
  GREEN_NEW_63: '#02642a',
  GREEN_NEW_64: '#016129',
  GREEN_NEW_65: '#005e27',
  GREEN_NEW_66: '#005c26',
  GREEN_NEW_67: '#005925',
  GREEN_NEW_68: '#005723',
  GREEN_NEW_69: '#005522',
  GREEN_NEW_7: '#a6f5b4',
  GREEN_NEW_70: '#005221',
  GREEN_NEW_71: '#00501f',
  GREEN_NEW_72: '#004d1e',
  GREEN_NEW_73: '#004b1c',
  GREEN_NEW_74: '#00481b',
  GREEN_NEW_75: '#00461a',
  GREEN_NEW_76: '#004418',
  GREEN_NEW_77: '#004117',
  GREEN_NEW_78: '#003f16',
  GREEN_NEW_79: '#003d14',
  GREEN_NEW_8: '#a2f2b0',
  GREEN_NEW_80: '#003a13',
  GREEN_NEW_81: '#003812',
  GREEN_NEW_82: '#003611',
  GREEN_NEW_83: '#00340f',
  GREEN_NEW_84: '#00310e',
  GREEN_NEW_85: '#002f0d',
  GREEN_NEW_86: '#002d0c',
  GREEN_NEW_87: '#002b0b',
  GREEN_NEW_88: '#002809',
  GREEN_NEW_89: '#002608',
  GREEN_NEW_9: '#9ff0ad',
  GREEN_NEW_90: '#002407',
  GREEN_NEW_91: '#002207',
  GREEN_NEW_92: '#002006',
  GREEN_NEW_93: '#001e05',
  GREEN_NEW_94: '#001b04',
  GREEN_NEW_95: '#001904',
  GREEN_NEW_96: '#001603',
  GREEN_NEW_97: '#001403',
  GREEN_NEW_98: '#001002',
  GREEN_NEW_99: '#000c02',
  GUILD_BOOSTING_BLUE: '#3e70dd',
  GUILD_BOOSTING_BLUE_FOR_GRADIENTS: '#3442d9',
  GUILD_BOOSTING_PINK: '#ff73fa',
  GUILD_BOOSTING_PURPLE: '#b377f3',
  GUILD_BOOSTING_PURPLE_FOR_GRADIENTS: '#9b44f7',
  HYPESQUAD_HOUSE_1: '#9c84ef',
  HYPESQUAD_HOUSE_2: '#f47b67',
  HYPESQUAD_HOUSE_3: '#45ddc0',
  INPUT_PLACEHOLDER_TEXT_DARK: '#87898c',
  LOL: '#021f25',
  LOL_TEXT_DARK: '#94620f',
  LOL_TEXT_LIGHT: '#cbaa62',
  NEUTRAL_1: '#ffffff',
  NEUTRAL_10: '#dbdcdf',
  NEUTRAL_100: '#000000',
  NEUTRAL_11: '#d7d8db',
  NEUTRAL_12: '#d3d4d7',
  NEUTRAL_13: '#d0d0d4',
  NEUTRAL_14: '#ccccd0',
  NEUTRAL_15: '#c8c8cd',
  NEUTRAL_16: '#c4c5c9',
  NEUTRAL_17: '#c0c1c6',
  NEUTRAL_18: '#bcbdc2',
  NEUTRAL_19: '#b9b9bf',
  NEUTRAL_2: '#fbfbfb',
  NEUTRAL_20: '#b5b6bb',
  NEUTRAL_21: '#b1b2b8',
  NEUTRAL_22: '#adaeb4',
  NEUTRAL_23: '#aaaab1',
  NEUTRAL_24: '#a6a7ad',
  NEUTRAL_25: '#a2a3aa',
  NEUTRAL_26: '#9f9fa6',
  NEUTRAL_27: '#9b9ca3',
  NEUTRAL_28: '#97989f',
  NEUTRAL_29: '#94959c',
  NEUTRAL_3: '#f7f7f8',
  NEUTRAL_30: '#909199',
  NEUTRAL_31: '#8c8d95',
  NEUTRAL_32: '#898a92',
  NEUTRAL_33: '#85868e',
  NEUTRAL_34: '#82838b',
  NEUTRAL_35: '#7e7f88',
  NEUTRAL_36: '#7b7c84',
  NEUTRAL_37: '#777881',
  NEUTRAL_38: '#74757e',
  NEUTRAL_39: '#70717a',
  NEUTRAL_4: '#f3f3f4',
  NEUTRAL_40: '#6d6e77',
  NEUTRAL_41: '#6a6b74',
  NEUTRAL_42: '#666771',
  NEUTRAL_43: '#63646d',
  NEUTRAL_44: '#5f606a',
  NEUTRAL_45: '#5c5d67',
  NEUTRAL_46: '#595a64',
  NEUTRAL_47: '#555760',
  NEUTRAL_48: '#52535d',
  NEUTRAL_49: '#4f505a',
  NEUTRAL_5: '#efeff0',
  NEUTRAL_50: '#4f505a',
  NEUTRAL_51: '#4d4e58',
  NEUTRAL_52: '#4c4d56',
  NEUTRAL_53: '#4a4b55',
  NEUTRAL_54: '#494a53',
  NEUTRAL_55: '#474851',
  NEUTRAL_56: '#46474f',
  NEUTRAL_57: '#44454d',
  NEUTRAL_58: '#43434c',
  NEUTRAL_59: '#41424a',
  NEUTRAL_6: '#ebebed',
  NEUTRAL_60: '#3f4048',
  NEUTRAL_61: '#3e3f46',
  NEUTRAL_62: '#3c3d45',
  NEUTRAL_63: '#3b3c43',
  NEUTRAL_64: '#393a41',
  NEUTRAL_65: '#383940',
  NEUTRAL_66: '#36373e',
  NEUTRAL_67: '#35363c',
  NEUTRAL_68: '#34343a',
  NEUTRAL_69: '#323339',
  NEUTRAL_7: '#e7e7e9',
  NEUTRAL_70: '#313137',
  NEUTRAL_71: '#2f3035',
  NEUTRAL_72: '#2e2e34',
  NEUTRAL_73: '#2c2d32',
  NEUTRAL_74: '#2b2b31',
  NEUTRAL_75: '#292a2f',
  NEUTRAL_76: '#28282d',
  NEUTRAL_77: '#27272c',
  NEUTRAL_78: '#25262a',
  NEUTRAL_79: '#242429',
  NEUTRAL_8: '#e3e3e6',
  NEUTRAL_80: '#222327',
  NEUTRAL_81: '#212125',
  NEUTRAL_82: '#202024',
  NEUTRAL_83: '#1e1f22',
  NEUTRAL_84: '#1d1d21',
  NEUTRAL_85: '#1b1c1f',
  NEUTRAL_86: '#1a1a1e',
  NEUTRAL_87: '#19191c',
  NEUTRAL_88: '#17181b',
  NEUTRAL_89: '#161619',
  NEUTRAL_9: '#dfe0e2',
  NEUTRAL_90: '#151518',
  NEUTRAL_91: '#131416',
  NEUTRAL_92: '#121214',
  NEUTRAL_93: '#101013',
  NEUTRAL_94: '#0e0e10',
  NEUTRAL_95: '#0c0c0e',
  NEUTRAL_96: '#0a0a0c',
  NEUTRAL_97: '#070709',
  NEUTRAL_98: '#050506',
  NEUTRAL_99: '#020203',
  OPACITY_1: '#97979f03',
  OPACITY_12: '#97979f1f',
  OPACITY_16: '#97979f29',
  OPACITY_20: '#97979f33',
  OPACITY_24: '#97979f3d',
  OPACITY_28: '#97979f47',
  OPACITY_32: '#97979f52',
  OPACITY_36: '#97979f5c',
  OPACITY_4: '#97979f0a',
  OPACITY_40: '#97979f66',
  OPACITY_44: '#97979f70',
  OPACITY_48: '#97979f7a',
  OPACITY_52: '#97979f85',
  OPACITY_56: '#97979f8f',
  OPACITY_60: '#97979f99',
  OPACITY_64: '#97979fa3',
  OPACITY_68: '#97979fad',
  OPACITY_72: '#97979fb8',
  OPACITY_76: '#97979fc2',
  OPACITY_8: '#97979f14',
  OPACITY_80: '#97979fcc',
  OPACITY_84: '#97979fd6',
  OPACITY_88: '#97979fe0',
  OPACITY_92: '#97979feb',
  OPACITY_96: '#97979ff5',
  OPACITY_BLACK_1: '#00000003',
  OPACITY_BLACK_12: '#0000001f',
  OPACITY_BLACK_16: '#00000029',
  OPACITY_BLACK_20: '#00000033',
  OPACITY_BLACK_24: '#0000003d',
  OPACITY_BLACK_28: '#00000047',
  OPACITY_BLACK_32: '#00000052',
  OPACITY_BLACK_36: '#0000005c',
  OPACITY_BLACK_4: '#0000000a',
  OPACITY_BLACK_40: '#00000066',
  OPACITY_BLACK_44: '#00000070',
  OPACITY_BLACK_48: '#0000007a',
  OPACITY_BLACK_52: '#00000085',
  OPACITY_BLACK_56: '#0000008f',
  OPACITY_BLACK_60: '#00000099',
  OPACITY_BLACK_64: '#000000a3',
  OPACITY_BLACK_68: '#000000ad',
  OPACITY_BLACK_72: '#000000b8',
  OPACITY_BLACK_76: '#000000c2',
  OPACITY_BLACK_8: '#00000014',
  OPACITY_BLACK_80: '#000000cc',
  OPACITY_BLACK_84: '#000000d6',
  OPACITY_BLACK_88: '#000000e0',
  OPACITY_BLACK_92: '#000000eb',
  OPACITY_BLACK_96: '#000000f5',
  OPACITY_BLUE_1: '#0074e303',
  OPACITY_BLUE_12: '#0074e31f',
  OPACITY_BLUE_16: '#0074e329',
  OPACITY_BLUE_20: '#0074e333',
  OPACITY_BLUE_24: '#0074e33d',
  OPACITY_BLUE_28: '#0074e347',
  OPACITY_BLUE_32: '#0074e352',
  OPACITY_BLUE_36: '#0074e35c',
  OPACITY_BLUE_4: '#0074e30a',
  OPACITY_BLUE_40: '#0074e366',
  OPACITY_BLUE_44: '#0074e370',
  OPACITY_BLUE_48: '#0074e37a',
  OPACITY_BLUE_52: '#0074e385',
  OPACITY_BLUE_56: '#0074e38f',
  OPACITY_BLUE_60: '#0074e399',
  OPACITY_BLUE_64: '#0074e3a3',
  OPACITY_BLUE_68: '#0074e3ad',
  OPACITY_BLUE_72: '#0074e3b8',
  OPACITY_BLUE_76: '#0074e3c2',
  OPACITY_BLUE_8: '#0074e314',
  OPACITY_BLUE_80: '#0074e3cc',
  OPACITY_BLUE_84: '#0074e3d6',
  OPACITY_BLUE_88: '#0074e3e0',
  OPACITY_BLUE_92: '#0074e3eb',
  OPACITY_BLUE_96: '#0074e3f5',
  OPACITY_BLURPLE_1: '#5865f203',
  OPACITY_BLURPLE_12: '#5865f21f',
  OPACITY_BLURPLE_16: '#5865f229',
  OPACITY_BLURPLE_20: '#5865f233',
  OPACITY_BLURPLE_24: '#5865f23d',
  OPACITY_BLURPLE_28: '#5865f247',
  OPACITY_BLURPLE_32: '#5865f252',
  OPACITY_BLURPLE_36: '#5865f25c',
  OPACITY_BLURPLE_4: '#5865f20a',
  OPACITY_BLURPLE_40: '#5865f266',
  OPACITY_BLURPLE_44: '#5865f270',
  OPACITY_BLURPLE_48: '#5865f27a',
  OPACITY_BLURPLE_52: '#5865f285',
  OPACITY_BLURPLE_56: '#5865f28f',
  OPACITY_BLURPLE_60: '#5865f299',
  OPACITY_BLURPLE_64: '#5865f2a3',
  OPACITY_BLURPLE_68: '#5865f2ad',
  OPACITY_BLURPLE_72: '#5865f2b8',
  OPACITY_BLURPLE_76: '#5865f2c2',
  OPACITY_BLURPLE_8: '#5865f214',
  OPACITY_BLURPLE_80: '#5865f2cc',
  OPACITY_BLURPLE_84: '#5865f2d6',
  OPACITY_BLURPLE_88: '#5865f2e0',
  OPACITY_BLURPLE_92: '#5865f2eb',
  OPACITY_BLURPLE_96: '#5865f2f5',
  OPACITY_GREEN_1: '#00863a03',
  OPACITY_GREEN_12: '#00863a1f',
  OPACITY_GREEN_16: '#00863a29',
  OPACITY_GREEN_20: '#00863a33',
  OPACITY_GREEN_24: '#00863a3d',
  OPACITY_GREEN_28: '#00863a47',
  OPACITY_GREEN_32: '#00863a52',
  OPACITY_GREEN_36: '#00863a5c',
  OPACITY_GREEN_4: '#00863a0a',
  OPACITY_GREEN_40: '#00863a66',
  OPACITY_GREEN_44: '#00863a70',
  OPACITY_GREEN_48: '#00863a7a',
  OPACITY_GREEN_52: '#00863a85',
  OPACITY_GREEN_56: '#00863a8f',
  OPACITY_GREEN_60: '#00863a99',
  OPACITY_GREEN_64: '#00863aa3',
  OPACITY_GREEN_68: '#00863aad',
  OPACITY_GREEN_72: '#00863ab8',
  OPACITY_GREEN_76: '#00863ac2',
  OPACITY_GREEN_8: '#00863a14',
  OPACITY_GREEN_80: '#00863acc',
  OPACITY_GREEN_84: '#00863ad6',
  OPACITY_GREEN_88: '#00863ae0',
  OPACITY_GREEN_92: '#00863aeb',
  OPACITY_GREEN_96: '#00863af5',
  OPACITY_ORANGE_1: '#bd4f0003',
  OPACITY_ORANGE_12: '#bd4f001f',
  OPACITY_ORANGE_16: '#bd4f0029',
  OPACITY_ORANGE_20: '#bd4f0033',
  OPACITY_ORANGE_24: '#bd4f003d',
  OPACITY_ORANGE_28: '#bd4f0047',
  OPACITY_ORANGE_32: '#bd4f0052',
  OPACITY_ORANGE_36: '#bd4f005c',
  OPACITY_ORANGE_4: '#bd4f000a',
  OPACITY_ORANGE_40: '#bd4f0066',
  OPACITY_ORANGE_44: '#bd4f0070',
  OPACITY_ORANGE_48: '#bd4f007a',
  OPACITY_ORANGE_52: '#bd4f0085',
  OPACITY_ORANGE_56: '#bd4f008f',
  OPACITY_ORANGE_60: '#bd4f0099',
  OPACITY_ORANGE_64: '#bd4f00a3',
  OPACITY_ORANGE_68: '#bd4f00ad',
  OPACITY_ORANGE_72: '#bd4f00b8',
  OPACITY_ORANGE_76: '#bd4f00c2',
  OPACITY_ORANGE_8: '#bd4f0014',
  OPACITY_ORANGE_80: '#bd4f00cc',
  OPACITY_ORANGE_84: '#bd4f00d6',
  OPACITY_ORANGE_88: '#bd4f00e0',
  OPACITY_ORANGE_92: '#bd4f00eb',
  OPACITY_ORANGE_96: '#bd4f00f5',
  OPACITY_PINK_1: '#ff4cd203',
  OPACITY_PINK_12: '#ff4cd21f',
  OPACITY_PINK_16: '#ff4cd229',
  OPACITY_PINK_20: '#ff4cd233',
  OPACITY_PINK_24: '#ff4cd23d',
  OPACITY_PINK_28: '#ff4cd247',
  OPACITY_PINK_32: '#ff4cd252',
  OPACITY_PINK_36: '#ff4cd25c',
  OPACITY_PINK_4: '#ff4cd20a',
  OPACITY_PINK_40: '#ff4cd266',
  OPACITY_PINK_44: '#ff4cd270',
  OPACITY_PINK_48: '#ff4cd27a',
  OPACITY_PINK_52: '#ff4cd285',
  OPACITY_PINK_56: '#ff4cd28f',
  OPACITY_PINK_60: '#ff4cd299',
  OPACITY_PINK_64: '#ff4cd2a3',
  OPACITY_PINK_68: '#ff4cd2ad',
  OPACITY_PINK_72: '#ff4cd2b8',
  OPACITY_PINK_76: '#ff4cd2c2',
  OPACITY_PINK_8: '#ff4cd214',
  OPACITY_PINK_80: '#ff4cd2cc',
  OPACITY_PINK_84: '#ff4cd2d6',
  OPACITY_PINK_88: '#ff4cd2e0',
  OPACITY_PINK_92: '#ff4cd2eb',
  OPACITY_PINK_96: '#ff4cd2f5',
  OPACITY_RED_1: '#d22d3903',
  OPACITY_RED_12: '#d22d391f',
  OPACITY_RED_16: '#d22d3929',
  OPACITY_RED_20: '#d22d3933',
  OPACITY_RED_24: '#d22d393d',
  OPACITY_RED_28: '#d22d3947',
  OPACITY_RED_32: '#d22d3952',
  OPACITY_RED_36: '#d22d395c',
  OPACITY_RED_4: '#d22d390a',
  OPACITY_RED_40: '#d22d3966',
  OPACITY_RED_44: '#d22d3970',
  OPACITY_RED_48: '#d22d397a',
  OPACITY_RED_52: '#d22d3985',
  OPACITY_RED_56: '#d22d398f',
  OPACITY_RED_60: '#d22d3999',
  OPACITY_RED_64: '#d22d39a3',
  OPACITY_RED_68: '#d22d39ad',
  OPACITY_RED_72: '#d22d39b8',
  OPACITY_RED_76: '#d22d39c2',
  OPACITY_RED_8: '#d22d3914',
  OPACITY_RED_80: '#d22d39cc',
  OPACITY_RED_84: '#d22d39d6',
  OPACITY_RED_88: '#d22d39e0',
  OPACITY_RED_92: '#d22d39eb',
  OPACITY_RED_96: '#d22d39f5',
  OPACITY_TEAL_1: '#00818a03',
  OPACITY_TEAL_12: '#00818a1f',
  OPACITY_TEAL_16: '#00818a29',
  OPACITY_TEAL_20: '#00818a33',
  OPACITY_TEAL_24: '#00818a3d',
  OPACITY_TEAL_28: '#00818a47',
  OPACITY_TEAL_32: '#00818a52',
  OPACITY_TEAL_36: '#00818a5c',
  OPACITY_TEAL_4: '#00818a0a',
  OPACITY_TEAL_40: '#00818a66',
  OPACITY_TEAL_44: '#00818a70',
  OPACITY_TEAL_48: '#00818a7a',
  OPACITY_TEAL_52: '#00818a85',
  OPACITY_TEAL_56: '#00818a8f',
  OPACITY_TEAL_60: '#00818a99',
  OPACITY_TEAL_64: '#00818aa3',
  OPACITY_TEAL_68: '#00818aad',
  OPACITY_TEAL_72: '#00818ab8',
  OPACITY_TEAL_76: '#00818ac2',
  OPACITY_TEAL_8: '#00818a14',
  OPACITY_TEAL_80: '#00818acc',
  OPACITY_TEAL_84: '#00818ad6',
  OPACITY_TEAL_88: '#00818ae0',
  OPACITY_TEAL_92: '#00818aeb',
  OPACITY_TEAL_96: '#00818af5',
  OPACITY_WHITE_1: '#ffffff03',
  OPACITY_WHITE_12: '#ffffff1f',
  OPACITY_WHITE_16: '#ffffff29',
  OPACITY_WHITE_20: '#ffffff33',
  OPACITY_WHITE_24: '#ffffff3d',
  OPACITY_WHITE_28: '#ffffff47',
  OPACITY_WHITE_32: '#ffffff52',
  OPACITY_WHITE_36: '#ffffff5c',
  OPACITY_WHITE_4: '#ffffff0a',
  OPACITY_WHITE_40: '#ffffff66',
  OPACITY_WHITE_44: '#ffffff70',
  OPACITY_WHITE_48: '#ffffff7a',
  OPACITY_WHITE_52: '#ffffff85',
  OPACITY_WHITE_56: '#ffffff8f',
  OPACITY_WHITE_60: '#ffffff99',
  OPACITY_WHITE_64: '#ffffffa3',
  OPACITY_WHITE_68: '#ffffffad',
  OPACITY_WHITE_72: '#ffffffb8',
  OPACITY_WHITE_76: '#ffffffc2',
  OPACITY_WHITE_8: '#ffffff14',
  OPACITY_WHITE_80: '#ffffffcc',
  OPACITY_WHITE_84: '#ffffffd6',
  OPACITY_WHITE_88: '#ffffffe0',
  OPACITY_WHITE_92: '#ffffffeb',
  OPACITY_WHITE_96: '#fffffff5',
  OPACITY_YELLOW_1: '#a1630003',
  OPACITY_YELLOW_12: '#a163001f',
  OPACITY_YELLOW_16: '#a1630029',
  OPACITY_YELLOW_20: '#a1630033',
  OPACITY_YELLOW_24: '#a163003d',
  OPACITY_YELLOW_28: '#a1630047',
  OPACITY_YELLOW_32: '#a1630052',
  OPACITY_YELLOW_36: '#a163005c',
  OPACITY_YELLOW_4: '#a163000a',
  OPACITY_YELLOW_40: '#a1630066',
  OPACITY_YELLOW_44: '#a1630070',
  OPACITY_YELLOW_48: '#a163007a',
  OPACITY_YELLOW_52: '#a1630085',
  OPACITY_YELLOW_56: '#a163008f',
  OPACITY_YELLOW_60: '#a1630099',
  OPACITY_YELLOW_64: '#a16300a3',
  OPACITY_YELLOW_68: '#a16300ad',
  OPACITY_YELLOW_72: '#a16300b8',
  OPACITY_YELLOW_76: '#a16300c2',
  OPACITY_YELLOW_8: '#a1630014',
  OPACITY_YELLOW_80: '#a16300cc',
  OPACITY_YELLOW_84: '#a16300d6',
  OPACITY_YELLOW_88: '#a16300e0',
  OPACITY_YELLOW_92: '#a16300eb',
  OPACITY_YELLOW_96: '#a16300f5',
  ORANGE_100: '#fff8f5',
  ORANGE_130: '#fff4ed',
  ORANGE_160: '#feeadf',
  ORANGE_200: '#fddecd',
  ORANGE_230: '#fccfb2',
  ORANGE_260: '#fcbd95',
  ORANGE_300: '#fbab70',
  ORANGE_330: '#fa9746',
  ORANGE_345: '#f1882a',
  ORANGE_360: '#db7628',
  ORANGE_400: '#c46926',
  ORANGE_430: '#ac591f',
  ORANGE_460: '#9b4c19',
  ORANGE_500: '#8c4013',
  ORANGE: '#8c4013',
  ORANGE_530: '#7b3710',
  ORANGE_560: '#6d300e',
  ORANGE_600: '#5f2b0b',
  ORANGE_630: '#56260a',
  ORANGE_660: '#4c2209',
  ORANGE_700: '#431e09',
  ORANGE_730: '#3b1a07',
  ORANGE_760: '#331606',
  ORANGE_800: '#2d1305',
  ORANGE_830: '#261005',
  ORANGE_860: '#200e05',
  ORANGE_900: '#190d04',
  ORANGE_NEW_1: '#ffe1d3',
  ORANGE_NEW_10: '#ffc39f',
  ORANGE_NEW_100: '#090001',
  ORANGE_NEW_11: '#ffc09a',
  ORANGE_NEW_12: '#ffbd95',
  ORANGE_NEW_13: '#ffba90',
  ORANGE_NEW_14: '#ffb78b',
  ORANGE_NEW_15: '#ffb487',
  ORANGE_NEW_16: '#feb182',
  ORANGE_NEW_17: '#fcad7e',
  ORANGE_NEW_18: '#fbaa7a',
  ORANGE_NEW_19: '#f9a775',
  ORANGE_NEW_2: '#ffddcd',
  ORANGE_NEW_20: '#f7a471',
  ORANGE_NEW_21: '#f6a16d',
  ORANGE_NEW_22: '#f49e6a',
  ORANGE_NEW_23: '#f29b66',
  ORANGE_NEW_24: '#f09862',
  ORANGE_NEW_25: '#ee955e',
  ORANGE_NEW_26: '#ec935b',
  ORANGE_NEW_27: '#ea9057',
  ORANGE_NEW_28: '#e88d54',
  ORANGE_NEW_29: '#e68a50',
  ORANGE_NEW_3: '#ffdac6',
  ORANGE_NEW_30: '#e4874d',
  ORANGE_NEW_31: '#e28449',
  ORANGE_NEW_32: '#e08146',
  ORANGE_NEW_33: '#de7e43',
  ORANGE_NEW_34: '#dc7b3f',
  ORANGE_NEW_35: '#da783c',
  ORANGE_NEW_36: '#d87539',
  ORANGE_NEW_37: '#d67236',
  ORANGE_NEW_38: '#d47032',
  ORANGE_NEW_39: '#d26d2f',
  ORANGE_NEW_4: '#ffd7c0',
  ORANGE_NEW_40: '#d06a2b',
  ORANGE_NEW_41: '#ce6728',
  ORANGE_NEW_42: '#cc6424',
  ORANGE_NEW_43: '#ca6120',
  ORANGE_NEW_44: '#c75e1c',
  ORANGE_NEW_45: '#c55b18',
  ORANGE_NEW_46: '#c35813',
  ORANGE_NEW_47: '#c1550e',
  ORANGE_NEW_48: '#bf5207',
  ORANGE_NEW_49: '#bd4f00',
  ORANGE_NEW_5: '#ffd3ba',
  ORANGE_NEW_50: '#bd4f00',
  ORANGE_NEW_51: '#b94d01',
  ORANGE_NEW_52: '#b54c02',
  ORANGE_NEW_53: '#b14a03',
  ORANGE_NEW_54: '#ae4803',
  ORANGE_NEW_55: '#aa4703',
  ORANGE_NEW_56: '#a64503',
  ORANGE_NEW_57: '#a34303',
  ORANGE_NEW_58: '#9f4203',
  ORANGE_NEW_59: '#9b4002',
  ORANGE_NEW_6: '#ffd0b4',
  ORANGE_NEW_60: '#983e02',
  ORANGE_NEW_61: '#943c02',
  ORANGE_NEW_62: '#913b01',
  ORANGE_NEW_63: '#8d3901',
  ORANGE_NEW_64: '#8a3700',
  ORANGE_NEW_65: '#873500',
  ORANGE_NEW_66: '#833400',
  ORANGE_NEW_67: '#803200',
  ORANGE_NEW_68: '#7d3000',
  ORANGE_NEW_69: '#792e00',
  ORANGE_NEW_7: '#ffcdaf',
  ORANGE_NEW_70: '#762d00',
  ORANGE_NEW_71: '#732b00',
  ORANGE_NEW_72: '#702900',
  ORANGE_NEW_73: '#6c2700',
  ORANGE_NEW_74: '#692600',
  ORANGE_NEW_75: '#662400',
  ORANGE_NEW_76: '#632200',
  ORANGE_NEW_77: '#602000',
  ORANGE_NEW_78: '#5d1f00',
  ORANGE_NEW_79: '#5a1d00',
  ORANGE_NEW_8: '#ffcaa9',
  ORANGE_NEW_80: '#571b00',
  ORANGE_NEW_81: '#531900',
  ORANGE_NEW_82: '#501800',
  ORANGE_NEW_83: '#4d1600',
  ORANGE_NEW_84: '#4a1400',
  ORANGE_NEW_85: '#471300',
  ORANGE_NEW_86: '#451100',
  ORANGE_NEW_87: '#420f00',
  ORANGE_NEW_88: '#3f0e00',
  ORANGE_NEW_89: '#3c0c00',
  ORANGE_NEW_9: '#ffc6a4',
  ORANGE_NEW_90: '#390a00',
  ORANGE_NEW_91: '#360900',
  ORANGE_NEW_92: '#330700',
  ORANGE_NEW_93: '#300600',
  ORANGE_NEW_94: '#2d0500',
  ORANGE_NEW_95: '#2a0300',
  ORANGE_NEW_96: '#260200',
  ORANGE_NEW_97: '#210100',
  ORANGE_NEW_98: '#1b0000',
  ORANGE_NEW_99: '#140001',
  PARTNER: '#4087ed',
  PAYPAL: '#13216b',
  PINK_1: '#ffd3f8',
  PINK_10: '#ffbef0',
  PINK_100: '#000000',
  PINK_11: '#ffbcef',
  PINK_12: '#ffbaef',
  PINK_13: '#ffb7ee',
  PINK_14: '#ffb4ed',
  PINK_15: '#ffb2ec',
  PINK_16: '#ffafec',
  PINK_17: '#ffadeb',
  PINK_18: '#ffaaea',
  PINK_19: '#ffa7e9',
  PINK_2: '#ffd1f7',
  PINK_20: '#ffa5e8',
  PINK_21: '#ffa2e8',
  PINK_22: '#ff9fe7',
  PINK_23: '#ff9ce6',
  PINK_24: '#ff99e6',
  PINK_25: '#ff96e5',
  PINK_26: '#ff93e4',
  PINK_27: '#ff90e4',
  PINK_28: '#ff8de3',
  PINK_29: '#ff8ae2',
  PINK_3: '#ffcff7',
  PINK_30: '#ff87e2',
  PINK_31: '#ff84e1',
  PINK_32: '#ff80e0',
  PINK_33: '#ff7de0',
  PINK_34: '#ff7adf',
  PINK_35: '#ff76df',
  PINK_36: '#ff74de',
  PINK_37: '#ff71dd',
  PINK_38: '#ff6edc',
  PINK_39: '#ff6cdb',
  PINK_4: '#ffccf6',
  PINK_40: '#ff69da',
  PINK_41: '#ff66d9',
  PINK_42: '#ff63d8',
  PINK_43: '#ff60d7',
  PINK_44: '#ff5dd6',
  PINK_45: '#ff5ad5',
  PINK_46: '#ff57d4',
  PINK_47: '#ff53d4',
  PINK_48: '#ff50d3',
  PINK_49: '#ff4cd2',
  PINK_5: '#ffcaf5',
  PINK_50: '#ff4cd2',
  PINK_51: '#f94bcd',
  PINK_52: '#f34ac8',
  PINK_53: '#ee49c4',
  PINK_54: '#e848bf',
  PINK_55: '#e346ba',
  PINK_56: '#dd45b6',
  PINK_57: '#d843b1',
  PINK_58: '#d242ad',
  PINK_59: '#cd40a8',
  PINK_6: '#ffc8f4',
  PINK_60: '#c83fa4',
  PINK_61: '#c33da0',
  PINK_62: '#bd3c9b',
  PINK_63: '#b83a97',
  PINK_64: '#b33893',
  PINK_65: '#ae378f',
  PINK_66: '#a9358a',
  PINK_67: '#a53386',
  PINK_68: '#a03182',
  PINK_69: '#9b307e',
  PINK_7: '#ffc6f3',
  PINK_70: '#962e7a',
  PINK_71: '#912c76',
  PINK_72: '#8d2a72',
  PINK_73: '#88286e',
  PINK_74: '#83276a',
  PINK_75: '#7f2566',
  PINK_76: '#7a2363',
  PINK_77: '#76215f',
  PINK_78: '#71205b',
  PINK_79: '#6d1e57',
  PINK_8: '#ffc3f2',
  PINK_80: '#681c53',
  PINK_81: '#641b50',
  PINK_82: '#5f194c',
  PINK_83: '#5b1748',
  PINK_84: '#571645',
  PINK_85: '#521441',
  PINK_86: '#4e133e',
  PINK_87: '#4a113a',
  PINK_88: '#450f37',
  PINK_89: '#410e33',
  PINK_9: '#ffc1f1',
  PINK_90: '#3d0d30',
  PINK_91: '#390b2c',
  PINK_92: '#350a29',
  PINK_93: '#310826',
  PINK_94: '#2d0722',
  PINK_95: '#28061f',
  PINK_96: '#24051b',
  PINK_97: '#1e0416',
  PINK_98: '#170310',
  PINK_99: '#0d0208',
  PLAYSTATION: '#032f87',
  PLUM_23_ALPHA: '#bcbcf01a',
  PLUM_0: '#f9f9fa',
  PLUM_1: '#f3f3f4',
  PLUM_10: '#818491',
  PLUM_11: '#6c6f7c',
  PLUM_12: '#5b5e6a',
  PLUM_13: '#4d505b',
  PLUM_14: '#41434d',
  PLUM_15: '#383a43',
  PLUM_16: '#31323b',
  PLUM_17: '#2c2d35',
  PLUM_18: '#26272f',
  PLUM_19: '#212229',
  PLUM_2: '#ecedef',
  PLUM_20: '#1c1d23',
  PLUM_21: '#18191f',
  PLUM_22: '#16161c',
  PLUM_23: '#131318',
  PLUM_24: '#0f1014',
  PLUM_25: '#0c0c10',
  PLUM_26: '#08080b',
  PLUM_3: '#e4e5e8',
  PLUM_4: '#dddee1',
  PLUM_5: '#d3d5d9',
  PLUM_6: '#c7c8ce',
  PLUM_7: '#b8bac1',
  PLUM_8: '#a8aab4',
  PLUM_9: '#9597a3',
  PREMIUM_NITRO_PINK_DARK: '#b64ab7',
  PREMIUM_NITRO_PINK_LIGHT: '#c269c3',
  PREMIUM_PERK_BLUE: '#80a6ff',
  PREMIUM_PERK_BLUE_ALT: '#9cb8ff',
  PREMIUM_PERK_DARK_BLUE: '#4173da',
  PREMIUM_PERK_GOLD: '#faa61a',
  PREMIUM_PERK_GREEN: '#86dcc5',
  PREMIUM_PERK_LIGHT_BLUE: '#aec7ff',
  PREMIUM_PERK_ORANGE: '#fc964b',
  PREMIUM_PERK_PINK: '#ff80f4',
  PREMIUM_PERK_PURPLE: '#d09aff',
  PREMIUM_PERK_YELLOW: '#fed648',
  PREMIUM_TIER_0_BLUE: '#007cc2',
  PREMIUM_TIER_0_BLUE_FOR_GRADIENTS: '#007cc2',
  PREMIUM_TIER_0_BLUE_FOR_GRADIENTS_2: '#1776cf',
  PREMIUM_TIER_0_HEADER_GRADIENT_1: '#3736bb',
  PREMIUM_TIER_0_HEADER_GRADIENT_2: '#4670e8',
  PREMIUM_TIER_0_HEADER_GRADIENT_3: '#8377eb',
  PREMIUM_TIER_0_HEADER_GRADIENT_4: '#e782f1',
  PREMIUM_TIER_0_HEADER_GRADIENT_5: '#df90af',
  PREMIUM_TIER_0_PURPLE: '#5865f2',
  PREMIUM_TIER_0_PURPLE_FOR_GRADIENTS: '#5865f2',
  PREMIUM_TIER_1_BLUE: '#738ef5',
  PREMIUM_TIER_1_BLUE_FOR_GRADIENTS: '#5865f2',
  PREMIUM_TIER_1_DARK_BLUE_FOR_GRADIENTS: '#3442d9',
  PREMIUM_TIER_1_PURPLE: '#b3aeff',
  PREMIUM_TIER_2_PINK: '#e292aa',
  PREMIUM_TIER_2_PINK_FOR_GRADIENTS: '#ab5d8a',
  PREMIUM_TIER_2_PINK_FOR_GRADIENTS_2: '#b73ec1',
  PREMIUM_TIER_2_PURPLE: '#b473f5',
  PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS: '#8547c6',
  PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS_2: '#b845c1',
  PRIMARY_100: '#f9f9f9',
  PRIMARY_130: '#f2f3f5',
  PRIMARY_160: '#ebedef',
  PRIMARY_200: '#e3e5e8',
  PRIMARY_230: '#dbdee1',
  PRIMARY_260: '#d2d5d9',
  PRIMARY_300: '#c4c9ce',
  PRIMARY_330: '#b5bac1',
  PRIMARY_345: '#a5abb3',
  PRIMARY_360: '#949ba4',
  PRIMARY_400: '#80848e',
  PRIMARY_430: '#6d6f78',
  PRIMARY_460: '#5c5e66',
  PRIMARY_500: '#4e5058',
  PRIMARY: '#4e5058',
  PRIMARY_530: '#41434a',
  PRIMARY_560: '#383a40',
  PRIMARY_600: '#313338',
  PRIMARY_630: '#2b2d31',
  PRIMARY_645: '#282a2e',
  PRIMARY_660: '#232428',
  PRIMARY_700: '#1e1f22',
  PRIMARY_730: '#1a1b1e',
  PRIMARY_760: '#161719',
  PRIMARY_800: '#111214',
  PRIMARY_830: '#0c0c0d',
  PRIMARY_860: '#060607',
  PRIMARY_900: '#020202',
  RED_100: '#fef8f9',
  RED_130: '#fef4f4',
  RED_160: '#feeaea',
  RED_200: '#fdddde',
  RED_230: '#fbcdce',
  RED_260: '#fbbabb',
  RED_300: '#fba6a8',
  RED_330: '#fa9193',
  RED_345: '#fa777b',
  RED_360: '#f85b5f',
  RED_400: '#f23f43',
  RED_430: '#da373c',
  RED_460: '#bb3033',
  RED_500: '#a12829',
  RED: '#a12829',
  RED_530: '#8f2022',
  RED_560: '#7f1c1e',
  RED_600: '#70181a',
  RED_630: '#651517',
  RED_660: '#5a1314',
  RED_700: '#501012',
  RED_730: '#460e0f',
  RED_760: '#3f0b0c',
  RED_800: '#360a0b',
  RED_830: '#2e090a',
  RED_860: '#280808',
  RED_900: '#220606',
  RED_NEW_1: '#ffdbda',
  RED_NEW_10: '#ffbbb6',
  RED_NEW_100: '#040001',
  RED_NEW_11: '#ffb7b2',
  RED_NEW_12: '#ffb3ae',
  RED_NEW_13: '#ffafaa',
  RED_NEW_14: '#ffaba6',
  RED_NEW_15: '#ffa7a2',
  RED_NEW_16: '#ffa39d',
  RED_NEW_17: '#ff9f99',
  RED_NEW_18: '#ff9b95',
  RED_NEW_19: '#ff9791',
  RED_NEW_2: '#ffd7d6',
  RED_NEW_20: '#ff948e',
  RED_NEW_21: '#ff918b',
  RED_NEW_22: '#ff8d87',
  RED_NEW_23: '#ff8a84',
  RED_NEW_24: '#ff8681',
  RED_NEW_25: '#ff837e',
  RED_NEW_26: '#ff807b',
  RED_NEW_27: '#fe7c78',
  RED_NEW_28: '#fc7975',
  RED_NEW_29: '#fa7672',
  RED_NEW_3: '#ffd4d2',
  RED_NEW_30: '#f8736f',
  RED_NEW_31: '#f76f6c',
  RED_NEW_32: '#f56c69',
  RED_NEW_33: '#f36966',
  RED_NEW_34: '#f16563',
  RED_NEW_35: '#ef6260',
  RED_NEW_36: '#ed5f5d',
  RED_NEW_37: '#eb5b5b',
  RED_NEW_38: '#e95858',
  RED_NEW_39: '#e75455',
  RED_NEW_4: '#ffd0ce',
  RED_NEW_40: '#e55152',
  RED_NEW_41: '#e34d4f',
  RED_NEW_42: '#e14a4d',
  RED_NEW_43: '#df464a',
  RED_NEW_44: '#dc4247',
  RED_NEW_45: '#da3e44',
  RED_NEW_46: '#d83a41',
  RED_NEW_47: '#d6363f',
  RED_NEW_48: '#d4323c',
  RED_NEW_49: '#d22d39',
  RED_NEW_5: '#ffcdca',
  RED_NEW_50: '#d22d39',
  RED_NEW_51: '#ce2c38',
  RED_NEW_52: '#c92c37',
  RED_NEW_53: '#c52b36',
  RED_NEW_54: '#c12a35',
  RED_NEW_55: '#bc2934',
  RED_NEW_56: '#b82832',
  RED_NEW_57: '#b42831',
  RED_NEW_58: '#b02730',
  RED_NEW_59: '#ac262f',
  RED_NEW_6: '#ffc9c6',
  RED_NEW_60: '#a8242d',
  RED_NEW_61: '#a4232c',
  RED_NEW_62: '#a0222b',
  RED_NEW_63: '#9c2129',
  RED_NEW_64: '#982028',
  RED_NEW_65: '#941f27',
  RED_NEW_66: '#911e25',
  RED_NEW_67: '#8d1c24',
  RED_NEW_68: '#891b23',
  RED_NEW_69: '#851a21',
  RED_NEW_7: '#ffc6c2',
  RED_NEW_70: '#821920',
  RED_NEW_71: '#7e171f',
  RED_NEW_72: '#7a161d',
  RED_NEW_73: '#77151c',
  RED_NEW_74: '#73131b',
  RED_NEW_75: '#701219',
  RED_NEW_76: '#6c1118',
  RED_NEW_77: '#690f17',
  RED_NEW_78: '#650e16',
  RED_NEW_79: '#620d14',
  RED_NEW_8: '#ffc2be',
  RED_NEW_80: '#5e0b13',
  RED_NEW_81: '#5b0a12',
  RED_NEW_82: '#580911',
  RED_NEW_83: '#540810',
  RED_NEW_84: '#51060e',
  RED_NEW_85: '#4d050d',
  RED_NEW_86: '#4a050c',
  RED_NEW_87: '#47040b',
  RED_NEW_88: '#44030a',
  RED_NEW_89: '#400209',
  RED_NEW_9: '#ffbeba',
  RED_NEW_90: '#3d0208',
  RED_NEW_91: '#3a0107',
  RED_NEW_92: '#370107',
  RED_NEW_93: '#330006',
  RED_NEW_94: '#300005',
  RED_NEW_95: '#2c0005',
  RED_NEW_96: '#270004',
  RED_NEW_97: '#220003',
  RED_NEW_98: '#1b0003',
  RED_NEW_99: '#120002',
  REDDIT: '#ff4500',
  RIOT_GAMES: '#ea0029',
  ROLE_BLUE: '#206694',
  ROLE_BROWN: '#a84300',
  ROLE_BURGUNDY: '#ad1457',
  ROLE_DARK_BLUE: '#546e7a',
  ROLE_DARK_GREY: '#607d8b',
  ROLE_DARK_PURPLE: '#71368a',
  ROLE_DARK_TEAL: '#11806a',
  ROLE_DEFAULT: '#99aab5',
  ROLE_GREEN: '#1f8b4c',
  ROLE_GREY: '#979c9f',
  ROLE_LIGHT_BLUE: '#99aab5',
  ROLE_LIGHT_GREEN: '#2ecc71',
  ROLE_LIGHT_GREY: '#95a5a6',
  ROLE_MAGENTA: '#e91e63',
  ROLE_ORANGE: '#e67e22',
  ROLE_PURPLE: '#9b59b6',
  ROLE_SALMON: '#e74c3c',
  ROLE_SKY_BLUE: '#3498db',
  ROLE_TAN: '#c27c0e',
  ROLE_TEAL: '#1abc9c',
  ROLE_TERRACOTTA: '#992d22',
  ROLE_YELLOW: '#f1c40f',
  SAMSUNG: '#1429a0',
  SKYPE: '#009dd7',
  SPOTIFY: '#1db954',
  STEAM: '#182332',
  TEAL_100: '#f4fbfd',
  TEAL_130: '#e9f9fd',
  TEAL_160: '#d3f4fb',
  TEAL_200: '#b1eff9',
  TEAL_230: '#7ee7f7',
  TEAL_260: '#5edbef',
  TEAL_300: '#47cbe2',
  TEAL_330: '#35bcd5',
  TEAL_345: '#2eb0c9',
  TEAL_360: '#289fb6',
  TEAL_400: '#248da1',
  TEAL_430: '#207a8d',
  TEAL_460: '#1b6b7c',
  TEAL_500: '#175e6d',
  TEAL: '#175e6d',
  TEAL_530: '#13525f',
  TEAL_560: '#0f4954',
  TEAL_600: '#0c4049',
  TEAL_630: '#0a3942',
  TEAL_660: '#08333a',
  TEAL_700: '#062d34',
  TEAL_730: '#05272d',
  TEAL_760: '#042227',
  TEAL_800: '#031d21',
  TEAL_830: '#02191d',
  TEAL_860: '#021619',
  TEAL_900: '#011215',
  TEAL_NEW_1: '#b1ffff',
  TEAL_NEW_10: '#93e7ef',
  TEAL_NEW_100: '#00060b',
  TEAL_NEW_11: '#90e4ec',
  TEAL_NEW_12: '#8de1e9',
  TEAL_NEW_13: '#8adee7',
  TEAL_NEW_14: '#87dce4',
  TEAL_NEW_15: '#84d9e1',
  TEAL_NEW_16: '#81d6de',
  TEAL_NEW_17: '#7ed4dc',
  TEAL_NEW_18: '#7cd1d9',
  TEAL_NEW_19: '#79ced6',
  TEAL_NEW_2: '#adfcff',
  TEAL_NEW_20: '#76ccd4',
  TEAL_NEW_21: '#73c9d1',
  TEAL_NEW_22: '#70c6ce',
  TEAL_NEW_23: '#6dc4cc',
  TEAL_NEW_24: '#6ac1c9',
  TEAL_NEW_25: '#67bec6',
  TEAL_NEW_26: '#64bcc4',
  TEAL_NEW_27: '#61b9c1',
  TEAL_NEW_28: '#5fb6bf',
  TEAL_NEW_29: '#5cb4bc',
  TEAL_NEW_3: '#aafaff',
  TEAL_NEW_30: '#59b1b9',
  TEAL_NEW_31: '#56aeb7',
  TEAL_NEW_32: '#53acb4',
  TEAL_NEW_33: '#4fa9b2',
  TEAL_NEW_34: '#4ca7af',
  TEAL_NEW_35: '#49a4ac',
  TEAL_NEW_36: '#46a1aa',
  TEAL_NEW_37: '#429fa7',
  TEAL_NEW_38: '#3f9ca5',
  TEAL_NEW_39: '#3b9aa2',
  TEAL_NEW_4: '#a7f7ff',
  TEAL_NEW_40: '#3897a0',
  TEAL_NEW_41: '#34959d',
  TEAL_NEW_42: '#30929b',
  TEAL_NEW_43: '#2c9098',
  TEAL_NEW_44: '#278d96',
  TEAL_NEW_45: '#228b94',
  TEAL_NEW_46: '#1c8891',
  TEAL_NEW_47: '#15868f',
  TEAL_NEW_48: '#0c838c',
  TEAL_NEW_49: '#00818a',
  TEAL_NEW_5: '#a3f4fc',
  TEAL_NEW_50: '#00818a',
  TEAL_NEW_51: '#027e87',
  TEAL_NEW_52: '#037c85',
  TEAL_NEW_53: '#047982',
  TEAL_NEW_54: '#04767f',
  TEAL_NEW_55: '#05747c',
  TEAL_NEW_56: '#05717a',
  TEAL_NEW_57: '#056f77',
  TEAL_NEW_58: '#046c75',
  TEAL_NEW_59: '#046a72',
  TEAL_NEW_6: '#a0f1f9',
  TEAL_NEW_60: '#03676f',
  TEAL_NEW_61: '#02656d',
  TEAL_NEW_62: '#01626a',
  TEAL_NEW_63: '#016068',
  TEAL_NEW_64: '#005d65',
  TEAL_NEW_65: '#005b63',
  TEAL_NEW_66: '#005860',
  TEAL_NEW_67: '#00565e',
  TEAL_NEW_68: '#00535b',
  TEAL_NEW_69: '#005159',
  TEAL_NEW_7: '#9deff7',
  TEAL_NEW_70: '#004f57',
  TEAL_NEW_71: '#004c54',
  TEAL_NEW_72: '#004a52',
  TEAL_NEW_73: '#00474f',
  TEAL_NEW_74: '#00454d',
  TEAL_NEW_75: '#00434b',
  TEAL_NEW_76: '#004148',
  TEAL_NEW_77: '#003e46',
  TEAL_NEW_78: '#003c44',
  TEAL_NEW_79: '#003a42',
  TEAL_NEW_8: '#9aecf4',
  TEAL_NEW_80: '#00373f',
  TEAL_NEW_81: '#00353d',
  TEAL_NEW_82: '#00333b',
  TEAL_NEW_83: '#003139',
  TEAL_NEW_84: '#002f36',
  TEAL_NEW_85: '#002c34',
  TEAL_NEW_86: '#002a32',
  TEAL_NEW_87: '#002830',
  TEAL_NEW_88: '#00262e',
  TEAL_NEW_89: '#00242c',
  TEAL_NEW_9: '#96e9f1',
  TEAL_NEW_90: '#002229',
  TEAL_NEW_91: '#002027',
  TEAL_NEW_92: '#001e25',
  TEAL_NEW_93: '#001c23',
  TEAL_NEW_94: '#001921',
  TEAL_NEW_95: '#00171f',
  TEAL_NEW_96: '#00151c',
  TEAL_NEW_97: '#001219',
  TEAL_NEW_98: '#000e15',
  TEAL_NEW_99: '#000a11',
  TRANSPARENT: 'transparent',
  TWITCH: '#9147ff',
  TWITCH_SECONDARY: '#772ce8',
  TWITTER: '#1da1f2',
  WHITE: '#ffffff',
  WHITE_100: '#ffffff',
  WHITE_130: '#ffffff',
  WHITE_160: '#ffffff',
  WHITE_200: '#ffffff',
  WHITE_230: '#ffffff',
  WHITE_260: '#ffffff',
  WHITE_300: '#ffffff',
  WHITE_330: '#ffffff',
  WHITE_345: '#ffffff',
  WHITE_360: '#ffffff',
  WHITE_400: '#ffffff',
  WHITE_430: '#ffffff',
  WHITE_460: '#ffffff',
  WHITE_500: '#ffffff',
  WHITE_530: '#e8e8e8',
  WHITE_560: '#cfcfcf',
  WHITE_600: '#adadad',
  WHITE_630: '#969696',
  WHITE_660: '#838383',
  WHITE_700: '#666666',
  WHITE_730: '#5f5f5f',
  WHITE_760: '#585858',
  WHITE_800: '#4d4d4d',
  WHITE_830: '#3b3b3b',
  WHITE_860: '#262626',
  WHITE_900: '#0d0d0d',
  XBOX: '#107c10',
  YELLOW_100: '#fff8ef',
  YELLOW_130: '#fff4e8',
  YELLOW_160: '#ffebd3',
  YELLOW_200: '#fee0b6',
  YELLOW_230: '#fdd18c',
  YELLOW_260: '#fcc145',
  YELLOW_300: '#f0b232',
  YELLOW_330: '#e1a42a',
  YELLOW_345: '#d49824',
  YELLOW_360: '#bf861c',
  YELLOW_400: '#af7615',
  YELLOW_430: '#9a650d',
  YELLOW_460: '#8a5709',
  YELLOW_500: '#7c4b04',
  YELLOW: '#7c4b04',
  YELLOW_530: '#6d4104',
  YELLOW_560: '#613803',
  YELLOW_600: '#543203',
  YELLOW_630: '#4c2d03',
  YELLOW_660: '#432803',
  YELLOW_700: '#3b2303',
  YELLOW_730: '#351e02',
  YELLOW_760: '#2e1a02',
  YELLOW_800: '#271602',
  YELLOW_830: '#221302',
  YELLOW_860: '#1c1002',
  YELLOW_900: '#160e02',
  YELLOW_NEW_1: '#ffe6c9',
  YELLOW_NEW_10: '#f8cd98',
  YELLOW_NEW_100: '#0e0000',
  YELLOW_NEW_11: '#f6ca94',
  YELLOW_NEW_12: '#f4c78f',
  YELLOW_NEW_13: '#f2c48b',
  YELLOW_NEW_14: '#f0c186',
  YELLOW_NEW_15: '#eebe82',
  YELLOW_NEW_16: '#ecbc7e',
  YELLOW_NEW_17: '#eab97a',
  YELLOW_NEW_18: '#e7b676',
  YELLOW_NEW_19: '#e5b372',
  YELLOW_NEW_2: '#ffe3c3',
  YELLOW_NEW_20: '#e3b16e',
  YELLOW_NEW_21: '#e1ae6b',
  YELLOW_NEW_22: '#deab67',
  YELLOW_NEW_23: '#dca863',
  YELLOW_NEW_24: '#daa660',
  YELLOW_NEW_25: '#d8a35c',
  YELLOW_NEW_26: '#d5a059',
  YELLOW_NEW_27: '#d39d56',
  YELLOW_NEW_28: '#d19b52',
  YELLOW_NEW_29: '#ce984f',
  YELLOW_NEW_3: '#ffe1bd',
  YELLOW_NEW_30: '#cc954c',
  YELLOW_NEW_31: '#ca9348',
  YELLOW_NEW_32: '#c79045',
  YELLOW_NEW_33: '#c58d42',
  YELLOW_NEW_34: '#c38b3f',
  YELLOW_NEW_35: '#c1883c',
  YELLOW_NEW_36: '#be8538',
  YELLOW_NEW_37: '#bc8335',
  YELLOW_NEW_38: '#ba8032',
  YELLOW_NEW_39: '#b77d2f',
  YELLOW_NEW_4: '#ffdeb7',
  YELLOW_NEW_40: '#b57b2b',
  YELLOW_NEW_41: '#b37828',
  YELLOW_NEW_42: '#b17524',
  YELLOW_NEW_43: '#ae7320',
  YELLOW_NEW_44: '#ac701c',
  YELLOW_NEW_45: '#aa6d18',
  YELLOW_NEW_46: '#a86b13',
  YELLOW_NEW_47: '#a5680e',
  YELLOW_NEW_48: '#a36607',
  YELLOW_NEW_49: '#a16300',
  YELLOW_NEW_5: '#ffdbb2',
  YELLOW_NEW_50: '#a16300',
  YELLOW_NEW_51: '#9e6101',
  YELLOW_NEW_52: '#9b5f02',
  YELLOW_NEW_53: '#985c02',
  YELLOW_NEW_54: '#955a03',
  YELLOW_NEW_55: '#925803',
  YELLOW_NEW_56: '#8f5603',
  YELLOW_NEW_57: '#8c5403',
  YELLOW_NEW_58: '#895203',
  YELLOW_NEW_59: '#864f02',
  YELLOW_NEW_6: '#ffd8ad',
  YELLOW_NEW_60: '#834d02',
  YELLOW_NEW_61: '#804b01',
  YELLOW_NEW_62: '#7e4901',
  YELLOW_NEW_63: '#7b4700',
  YELLOW_NEW_64: '#784500',
  YELLOW_NEW_65: '#754300',
  YELLOW_NEW_66: '#724000',
  YELLOW_NEW_67: '#703e00',
  YELLOW_NEW_68: '#6d3c00',
  YELLOW_NEW_69: '#6a3a00',
  YELLOW_NEW_7: '#fed5a7',
  YELLOW_NEW_70: '#683800',
  YELLOW_NEW_71: '#653600',
  YELLOW_NEW_72: '#623400',
  YELLOW_NEW_73: '#603200',
  YELLOW_NEW_74: '#5d3000',
  YELLOW_NEW_75: '#5b2e00',
  YELLOW_NEW_76: '#582c00',
  YELLOW_NEW_77: '#552a00',
  YELLOW_NEW_78: '#532700',
  YELLOW_NEW_79: '#502500',
  YELLOW_NEW_8: '#fcd2a2',
  YELLOW_NEW_80: '#4e2300',
  YELLOW_NEW_81: '#4b2100',
  YELLOW_NEW_82: '#491f00',
  YELLOW_NEW_83: '#461d00',
  YELLOW_NEW_84: '#441b00',
  YELLOW_NEW_85: '#411900',
  YELLOW_NEW_86: '#3f1700',
  YELLOW_NEW_87: '#3c1500',
  YELLOW_NEW_88: '#3a1400',
  YELLOW_NEW_89: '#381200',
  YELLOW_NEW_9: '#facf9d',
  YELLOW_NEW_90: '#351000',
  YELLOW_NEW_91: '#330e00',
  YELLOW_NEW_92: '#300c00',
  YELLOW_NEW_93: '#2e0a00',
  YELLOW_NEW_94: '#2b0800',
  YELLOW_NEW_95: '#280600',
  YELLOW_NEW_96: '#250400',
  YELLOW_NEW_97: '#210200',
  YELLOW_NEW_98: '#1d0100',
  YELLOW_NEW_99: '#170000',
  YOUTUBE: '#cb2120',
});

export default Colors as Record<keyof typeof Colors, string>;
